// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { TimeZone } from './timeZone';

export class ChatAccountLocality {
    chatId: string;
    timeZone: TimeZone;
}